class Validate {
    static required(value) {
        if(!value) {
            return false;
        }
        return true;
    }
}

export default Validate;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/Validate.js